<!--
 * @Author: zyy
 * @Date: 2022-09-26 13:29:53
 * @LastEditors: zyy
 * @LastEditTime: 2022-09-26 17:32:30
 * @Description: default
-->

<template>
    <div class="modal-box">
        <a-table :columns="columns" :data-source="goods.item" rowKey="id" :pagination="false">
            <span slot="goods" slot-scope="data">
                <div class="flex">
                    <div><img :src="data.goods_image" alt="" height="40" width="40"></div>
                    <div style="margin-left:10px">
                        <div>{{data.goods_title}}</div>
                        <div style="font-size: 12px;color:#686767;">规格:{{data.goods_sku_text}}</div>
                    </div>
                </div>
            </span>
        </a-table>
        <div class="flex line-height-30 mt-20">
            <div class="mr-20">配送信息</div>
            <div>
                <div>配送方式:{{goods.dispatch_type_text}}</div>
                <div>收货人:{{`${addressInfo.consignee} ${addressInfo.phone}`}}</div>
                <div>收货地址:{{addressInfo.address}}</div>
            </div>
        </div>
        <div class="flex line-height-30 mt-20">
            <div class="mr-20">发货方式</div>
            <div>
                <a-radio :checked="true">手动发货</a-radio>
            </div>
        </div>
        <div class="flex-center mt-20">
            <div class="flex-center">
                <div class="mr-20">快递公司</div>
                <a-select v-model="courierCompany" placeholder="请选择快递公司" style="width:500px" 
                    :filterOption="filterOption" show-search>
                    <a-select-option :value="item.code" v-for="item in courierCompanyOptions">{{item.name}}
                    </a-select-option>
                </a-select>
            </div>
            <div class="flex-center" style="margin-left: 40px;">
                <div class="mr-20" style="width: 80px;">快递单号</div>
                <a-input v-model="courierNo" placeholder="请输入快递单号"></a-input>
            </div>
        </div>
    </div>
</template>
<script>
import GoodsOrderService from "@/io/goods/order.js";
import { resolve } from "path";
import { reject } from "q";

export default {
    components: {
        VNodes: {
            functional: true,
            render: (h, ctx) => ctx.props.vnodes,
        },
    },
    props: {
        goods: {
            type: Object,
            default: () => ({})
        },
        addressInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            courierCompany: [],
            courierNo: null,
            courierCompanyOptions: [],
            open: false,
            pagination: {
                page: 1,
                limit: 500,
                total: 0
            },
            columns: [
                {
                    title: "商品",
                    key: "goods",
                    scopedSlots: { customRender: "goods" },
                    width: 400
                },
                {
                    title: "数量",
                    dataIndex: "goods_num",
                    key: "goods_num",
                    width: 100
                }

            ]
        }
    },
    mounted() {
        this.getCourierCompany()
    },
    methods: {
        getCourierCompany() {
            GoodsOrderService.courierCompany({
                limit: this.pagination.limit,
                page: this.pagination.page
            }).then(res => {
                this.courierCompanyOptions = res.data?.rows
                // this.pagination.total = res.data?.total
            })
        },
        submit() {
            return new Promise((resolve, reject)=> {
                GoodsOrderService.deliverByInput({
                    id: this.addressInfo.id,
                    express_name: this.courierCompanyOptions.find(val => val.code == this.courierCompany)?.name,
                    express_code: this.courierCompany,
                    express_no: this.courierNo,
                    item_ids: this.goods.item.map(val => val.id)
                }).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        // popupScroll(){
        //     console.log(111)
        // }
    }
}
</script>
<style scoped lang="less">
.modal-box {
    max-height: 600px;
    overflow: hidden;
    overflow-y: auto;

}

.flex {
    display: flex;
}

.flex-center {
    display: flex;
    align-items: center;
}

.mr-20 {
    margin-right: 20px;
}

.mt-20 {
    margin-top: 20px;
}

.line-height-30 {
    line-height: 30px;
}
</style>